import { RadioQuestionConfig, RadioState } from '@gripp/shared-logic';
import { useController } from 'react-hook-form';
import { ControlledRadioButtons } from '../../../../../components/forms';
import { Colors } from '../../../../../themes/colors';
import { useFormContext } from '../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../types';

export const RadioQuestionExecutionForm: RoutineQuestionExecutionForm<
  RadioQuestionConfig,
  RadioState
> = (
  props: RoutineQuestionExecutionFormProps<RadioQuestionConfig, RadioState>
) => {
  const fieldPrefix = `responses.${props.responseIndex}`;
  const defaultValue = props?.isIssueEditRoutine
    ? props?.currentState?.state?.responses?.[props.responseIndex]?.option ?? []
    : [];
  const { control } = useFormContext();
  const { field } = useController({
    control: control,
    name: `${fieldPrefix}.option`,
    defaultValue: defaultValue,
  });

  return (
    <ControlledRadioButtons
      control={control}
      name={field.name}
      color={Colors.blue}
      options={props.config.options.map((option) => {
        return {
          value: option,
        };
      })}
    />
  );
};
